import { defineFurniture } from './types.js';

/** Everyday recreational sports and gym gear — distinct from the track/pool focus of stadium.ts and pool.ts. */
export const SPORTS_FURNITURE = {
  ...defineFurniture('sports', {
    badminton_net: {
      label: 'Badminton Net',
      description: 'Strung tight across the court. Mind the smash.',
      price: 350,
      solid: true,
      height: 1,
    },
    soccer_goal: {
      label: 'Soccer Goal',
      description: 'White frame, netted back. Shoot for the corner.',
      price: 450,
      solid: true,
      height: 1.6,
    },
    basketball_hoop: {
      label: 'Basketball Hoop',
      description: 'Chain net, chalked backboard. Swish.',
      price: 500,
      solid: true,
      height: 2.2,
    },
    gym_treadmill: {
      label: 'Treadmill',
      description: 'A console, a belt, and nowhere to go.',
      price: 700,
      solid: true,
      height: 1.2,
    },
    dumbbell_rack: {
      label: 'Dumbbell Rack',
      description: 'Weights racked light to heavy. Mostly light.',
      price: 400,
      solid: true,
      height: 1.3,
    },
    yoga_mat: {
      label: 'Yoga Mat',
      description: 'Unrolled and ready. Namaste.',
      price: 90,
      solid: false,
      height: 0.05,
    },
    ping_pong_table: {
      label: 'Ping Pong Table',
      description: 'Net up, paddles ready. Serve underhand.',
      price: 550,
      solid: true,
      height: 0.9,
    },
    gym_locker: {
      label: 'Gym Locker',
      description: 'Dented metal doors. Combination long forgotten.',
      price: 380,
      solid: true,
      height: 1.8,
    },
  }),
};
